import CODGhost from '../assets/images/ArtDesigns/CODGhost.jpg';
import VillageLady from '../assets/images/ArtDesigns/VillegeGirl.jpg';
import PoorChild from '../assets/images/ArtDesigns/PoorChild.jpg';
import SportGirl from '../assets/images/ArtDesigns/SportyLady.jpg';

let ArtsDesigns = [
  {
    name: 'Call of Duty Ghost Charactor',
    pic: CODGhost,
    tags: ['CallOfDuty', 'Ghost', 'GameCharactor', 'Game', 'Activision'],
  },
  {
    name: 'Sport Girl',
    pic: SportGirl,
    tags: ['SportGirl', 'Nike', 'CurlHair', 'Beautiful', 'Short', 'Thin'],
  },
  {
    name: 'Poor Child',
    pic: PoorChild,
    tags: ['Poor', 'Child', 'DrnkingWater', 'Hungry'],
  },
  {
    name: 'Village Lady',
    pic: VillageLady,
    tags: ['VillageGirl', 'Girl', 'Flowers', 'Beautiful'],
  },
];

export default ArtsDesigns;
